import { ChevronDownIcon } from '@heroicons/react/24/outline';
import * as SelectPrimitive from '@radix-ui/react-select';
import type * as React from 'react';
import { cn } from '@/shared/lib/utils';
import { type FormFieldSize, formFieldSizeVariants } from '../../helpers/field-size';
import { selectTriggerStyles } from '../helpers/trigger-styles';

/**
 * SelectTrigger - セレクトボックスのトリガー部分
 */
type SelectTriggerProps = React.ComponentPropsWithRef<typeof SelectPrimitive.Trigger> & {
  size?: FormFieldSize;
  /** クリアボタンが表示されているかどうか */
  shouldShowClearButton?: boolean;
};

export const SelectTrigger = ({
  className,
  children,
  ref,
  size = 'sm',
  id,
  shouldShowClearButton,
  ...props
}: SelectTriggerProps) => (
  <SelectPrimitive.Trigger
    ref={ref}
    id={id}
    className={cn(
      selectTriggerStyles({ height: 'fixed' }),
      '[&>span]:line-clamp-1',
      formFieldSizeVariants({ size }),
      className,
    )}
    {...props}
  >
    {children}
    <SelectPrimitive.Icon asChild>
      {!shouldShowClearButton && <ChevronDownIcon className="h-4 w-4 opacity-50" />}
    </SelectPrimitive.Icon>
  </SelectPrimitive.Trigger>
);
SelectTrigger.displayName = SelectPrimitive.Trigger.displayName;
